<template>
  <div class="fillcontain">
    <search-item @showDialog="showAddCoursePackageDialog" @showDelay="showDialogCourseDelay"></search-item>
    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        align="center"
        @select="selectTable"
        @select-all="selectAll"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          width="100"
          prop="id"
          label="id"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="packageName"
          label="课包名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="packageClasshour"
          label="课包课时数"
          align="center"
        ></el-table-column>
        <el-table-column
          width="100"
          prop="schoolInfoId"
          label="所属校区"
          align="left"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterSchoolInfo(scope.row)"
              disable-transitions
              >{{ scope.row.schoolInfoId }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="operation" align="left" label="操作">
          <template slot-scope="scope">
            <el-button
              type="warning"
              icon="edit"
              size="mini"
              @click="onEditCoursePackage(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              icon="delete"
              size="mini"
              @click="onDeleteCoursePackage(scope.row, scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :pageTotal="pageTotal"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
      <addFundDialog
        v-if="addCoursePackageDialog.show"
        :isShow="addCoursePackageDialog.show"
        :dialogRow="addCoursePackageDialog.dialogRow"
        :schoolInfoList="addCoursePackageDialog.schoolInfoList"
        @getCoursePackageList="getCoursePackageList"
        @closeDialog="hideAddFundDialog"
      ></addFundDialog>
    </div>
      <el-dialog title="课包延期" :visible.sync="delayDialogVisible" width="30%">
      <el-form :inline="true" :model="delayForm" class="demo-form-inline">
        <el-form-item label="天数">
          <el-input
            v-model="delayForm.dayNum"
            placeholder="请输入天数"
          ></el-input>
        </el-form-item>
        <el-form-item label="截止日期">
          <el-date-picker v-model="delayForm.beginTime" type="datetime" placeholder="请选择日期" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delayDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDelayDate"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as mutils from "@/utils/mUtils";
import SearchItem from "./components/searchItem";
import AddFundDialog from "./components/addCourseDialog";
import Pagination from "@/components/pagination";
import { myTime, formatDateTime, formatDateTime1 } from "../../utils/date.js";
import { getCoursePackages, deleteCoursePackage } from "@/api/coursepackage";
import {changeMemberCoursePackageClasshourDDL} from "@/api/memberCoursePackage";
import { getFormatSchoolInfo } from "@/api/school";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";

export default {
  data() {
    return {
      tableData: [],
      format_schoolinfo_list: {},
      schoolInfoData: [],
      tableHeight: 0,
      loading: false,
      idFlag: false,
      isShow: false, // 是否显示资金modal,默认为false
      editid: "",
      multipleSelection: [], //多选的数据
      sortnum: 0,
      addCoursePackageDialog: {
        show: false,
        dialogRow: {},
        schoolInfoList: {},
      },
      courseData: {
        page: 1,
        limit: 20,
      },
      pageTotal: 0,
      // 用于列表筛选
      fields: {},
      //延期课包对话框
      delayDialogVisible:false,
      delayForm:{
        dayNum:'',
        beginTime:''
      },
    };
  },
  filters: {
    filterTime(time) {
      return formatDateTime(time);
    },
    filterTime1(time) {
      var dd = myTime(time);
      return formatDateTime1(dd);
    },
  },
  components: {
    SearchItem,
    AddFundDialog,
    Pagination,
  },
  computed: {
    ...mapGetters(["courseSearch"]),
  },
  mounted() {
    this.getFormatSchoolInfo();
    this.getCoursePackageList();
  },
  methods: {
    getFormatSchoolInfo() {
      getFormatSchoolInfo().then((res) => {
        console.log(res);
        this.format_schoolinfo_list = res.data.data.format;
        this.schoolInfoData = res.data.data.filter;
        var schoolInfoList = {
          schoolInfoList: this.schoolInfoData,
        };
        this.addCoursePackageDialog.schoolInfoList = schoolInfoList;
      });
    },
    filterSchoolInfo(value, item) {
      console.log(item.schoolInfoId);
      console.log(this.format_schoolinfo_list);
      return this.format_schoolinfo_list[value] == item.schoolInfoId;
    },
    formatterSchoolInfo(item) {
      const type = parseInt(item.schoolInfoId);
      // console.log(this.format_schoolinfo_list[type]);
      return this.format_schoolinfo_list[type];
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = document.body.clientHeight - 300;
      });
    },
    //获取预约类型列表
    getCoursePackageList() {
      const para = this.courseData;
      getCoursePackages(para).then((res) => {
        console.log(res);
        this.loading = false;
        this.pageTotal = res.data.data.totalSize;
        this.tableData = res.data.data.data;
      });
    },
    // 显示添加预约类型弹窗
    showAddCoursePackageDialog(val) {
      this.$store.commit("SET_COURSEPACKAGE_DIALOG_TITLE", val);
      this.addCoursePackageDialog.show = true;
    },
    hideAddFundDialog() {
      this.addCoursePackageDialog.show = false;
    },
    // 上下分页
    handleCurrentChange(val) {
      this.courseData.page = val;
      this.getCoursePackageList();
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.courseData.limit = val;
      this.getCoursePackageList();
    },
    // 编辑操作方法
    onEditCoursePackage(row) {
      console.log(row);
      // var para = {}
      var param = Object.assign({}, row);
      this.addCoursePackageDialog.dialogRow = {
        param,
      };
      this.showAddCoursePackageDialog();
    },
    // 删除数据
    onDeleteCoursePackage(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          deleteCoursePackage(row.id).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            const para = {
              userName: getToken("USERNAME"),
              content: "删除(" + row.packageName + ")课包类型操作",
            };
            addOperationRecord(para).then((res) => {
              console.log(res);
            });
            this.getCoursePackageList();
          });
        })
        .catch(() => {});
    },
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    selectTable(val, row) {
      this.setSearchBtn(val);
    },
    // 用户全选checkbox时触发该事件
    selectAll(val) {
      this.setSearchBtn(val);
    },
    setSearchBtn(val) {
      let isFlag = true;
      if (val.length > 0) {
        isFlag = false;
      } else {
        isFlag = true;
      }
      this.$store.commit("SET_COURSE_SEARCHBTN_DISABLED", isFlag);
    },
    showDialogCourseDelay() {
      this.delayDialogVisible = true
    },
    submitDelayDate() {
      if(this.delayForm.dayNum !== '' &&this.delayForm.beginTime!== ''){
          changeMemberCoursePackageClasshourDDL(this.delayForm).then(res => {
          this.$message({
            message: "延期成功",
            type: "success",
          });
          this.delayForm = {dayNum:'',beginTime:''}
          this.delayDialogVisible = false;
          this.getFormatSchoolInfo();
          this.getCoursePackageList()
        })
      }else {
        this.$message({
          message: "请填写必要信息",
          type: "error",
        });
      }
    }
  },
};
</script>

<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
</style>


